module.exports = __webpack_public_path__ + "static/media/PC_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_EFICAZ_USANDO_PMI.961f95c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/gestao_proj/PC_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_EFICAZ_USANDO_PMI.png
// module id = 87
// module chunks = 0